import React from 'react';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import useStyles from 'isomorphic-style-loader/useStyles';
import PropTypes from 'prop-types';
import s from './Breadcrumbs.css';

export default function Breadcrumbs({ links, className }) {
  useStyles(s);
  return (
    <MuiBreadcrumbs separator=">" aria-label="breadcrumb" className={className}>
      {links.map(link => (
        <Link className={`${s.breadcrumbsLink} ${link.active && s.breadcrumbsActiveLink}`} href={link.href}>
          {link.title}
        </Link>
      ))}
    </MuiBreadcrumbs>
  );
}

Breadcrumbs.propTypes = {
  links: PropTypes.array.isRequired,
  className: PropTypes.string,
};

Breadcrumbs.defaultProps = {
  className: '',
};
